import { WORKING_DAY_IN_HOURS } from '../config/timeConstants';

export const formatDuration = (hours) => {
  const totalHours = parseFloat(hours);
  
  if (!totalHours || isNaN(totalHours)) {
    return '0h';
  }

  // Calculer les jours avec décimales
  const daysWithDecimals = totalHours / WORKING_DAY_IN_HOURS;

  // Vérifier si on peut afficher en demi-journées (avec une tolérance de 0.1)
  // Le nombre d'heures correspond à un multiple de demi-journées
  const halfDays = Math.round(daysWithDecimals * 2);
  const halfDayDiff = Math.abs(daysWithDecimals * 2 - halfDays);
  
  if (halfDayDiff < 0.1) {
    // Convertir en nombre de jours (1, 1.5, 2, 2.5, etc.)
    const roundedDays = halfDays / 2;
    return `${roundedDays}j`.replace('.', ',');
  }

  // Format standard pour les autres cas (jours, heures, minutes)
  const days = Math.floor(daysWithDecimals);
  const remainingHours = totalHours % WORKING_DAY_IN_HOURS;
  const justHours = Math.floor(remainingHours);
  const minutes = Math.round((remainingHours - justHours) * 60);

  const parts = [];
  
  if (days > 0) {
    parts.push(`${days}j`);
  }
  
  if (justHours > 0 || minutes > 0) {
    const hoursStr = justHours > 0 ? `${justHours}h` : '';
    const minutesStr = minutes > 0 ? `${minutes}min` : '';
    parts.push(`${hoursStr}${minutesStr}`);
  } else if (parts.length === 0) {
    parts.push('0h');
  }

  return parts.join(' ');
};
